import { AiOutlineFileSearch } from "react-icons/ai"; // Importing a search icon
// Skeleton row component
const TableRowSkeleton = ({ columns }) => (
  <div
    className="
      grid 
      items-center 
      px-10 py-6
      border-b border-[#D9D9D9]
      last:border-b-0
      animate-pulse
      "
    style={{
      gridTemplateColumns: columns.map((c) => c.width).join(" "),
      columnGap: "1.25rem",
    }}
  >
    {columns.map((col) => (
      <div
        key={col.key}
        className={
          col.key === "userInfo"
            ? "flex justify-start items-center gap-3"
            : col.align === "center"
              ? "flex justify-center items-center"
              : col.align === "right"
                ? "flex justify-end items-center"
                : "flex justify-start items-center"
        }
      >
        {col.key === "userInfo" ? (
          <div className="flex items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-gray-200"></div>
            <div>
              <div className="h-4 w-24 bg-gray-200 rounded mb-2"></div>
              <div className="h-3 w-32 bg-gray-200 rounded"></div>
            </div>
          </div>
        ) : col.key === "actions" ? (
          <div className="w-9 h-9 rounded-full bg-gray-200"></div>
        ) : col.key === "status" ? (
          <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
        ) : (
          <div className="h-4 w-16 bg-gray-200 rounded"></div>
        )}
      </div>
    ))}
  </div>
);

export default function Table({
  columns = [],
  data = [],
  isLoading = false,
  skeletonRows = 5,
  emptyMessage = "No records found",
}) {
  return (
    <div className="w-full overflow-x-auto">
      <div className="min-w-[1100px]">
        {/* HEADER */}
        <div
          className="
            grid 
            px-10 py-6
            bg-[#F3F6F9]
            border-b border-[#D9D9D9]
            text-[14px] font-semibold text-gray-900
            items-center
          "
          style={{
            gridTemplateColumns: columns.map((c) => c.width).join(" "),
            columnGap: "1.25rem", // FIXED GAP
          }}
        >
          {columns.map((col) => (
            <div
              key={col.key}
              className={
                col.key === "userInfo"
                  ? "text-center pr-[8.5rem]" // HEADER CENTERED
                  : col.align === "center"
                    ? "text-center"
                    : col.align === "right"
                      ? "text-right"
                      : "text-left"
              }
            >
              {col.label}
            </div>
          ))}
        </div>

        {/* SKELETON or ROWS */}
        {isLoading ? (
          Array.from({ length: skeletonRows }).map((_, i) => (
            <TableRowSkeleton key={i} columns={columns} />
          ))
        ) : data.length === 0 ? (
          <div className="flex items-center justify-center py-6">
            <AiOutlineFileSearch className="text-gray-500 w-8 h-8 mr-2" />
            <span className="text-gray-500 text-lg">{emptyMessage}</span>
          </div>
        ) : (
          data.map((row, i) => (
            <div
              key={i}
              className="
                    grid 
                    items-center 
                    px-10 py-6
                    border-b border-[#D9D9D9]
                    last:border-b-0
                    hover:bg-gray-50
                  "
              style={{
                gridTemplateColumns: columns.map((c) => c.width).join(" "),
                columnGap: "1.25rem", // SAME GAP FOR PERFECT ALIGNMENT
              }}
            >
              {columns.map((col) => (
                <div
                  key={col.key}
                  className={
                    col.key === "userInfo"
                      ? "flex justify-start items-center gap-3 min-w-0"
                      : col.align === "center"
                        ? "flex justify-center items-center min-w-0"
                        : col.align === "right"
                          ? "flex justify-end items-center min-w-0"
                          : "flex justify-start items-center min-w-0"
                  }
                >
                  <div className="break-words whitespace-normal">
                    {col.render ? col.render(row) : row[col.key]}
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
